import React, {useEffect, useContext, useState} from 'react';
import {Tabs} from 'antd';
import {EyeOutlined, CodeOutlined} from '@ant-design/icons';
import {set} from 'lodash';
import {OpenApiContext} from '../../openapi-context';
import {TechnicalEditor} from '../technical-editor';
import {Block} from '../block';
import {ServerBlock} from './servers-block';

export function ServersView({dispatch}) {
    const [serversData, setServersData] = useState();
    const openapi = useContext(OpenApiContext);

    useEffect(() => {
        if (openapi.state.servers) {
            const state = {};
            //This set function for display the TechnicalEditor
            set(state, 'servers', openapi.state.servers());
            setServersData(state);
        }
    }, [openapi.state]);

    function onSave(serversValue) {
        if (serversValue) {
            dispatch({type: 'update-servers', servers: {name: 'servers', value: serversValue}});
        }
    }

    function onTechnicalEdit(newData) {
        dispatch({type: 'update-servers', servers: {name: 'servers', value: newData.servers}});
    }

    return serversData ? (
        <div className="frontpage">
            <Tabs
                type="card"
                tabPlacement="right"
                id="modelTabs"
                items={[
                    {
                        key: 'visual',
                        label: <EyeOutlined />,
                        children: (
                            <div className="scrollableViewer">
                                <ServerBlock serversData={serversData} onSave={onSave} />
                            </div>
                        ),
                    },
                    {
                        key: 'technical',
                        label: <CodeOutlined />,
                        disabled: openapi.state.editMode,
                        children: (
                            <Block noEdit>
                                <TechnicalEditor object={serversData} update={onTechnicalEdit} />
                            </Block>
                        ),
                    },
                ]}
            />
        </div>
    ) : null;
}
